import axios, { getAuthHeaders } from './config'

export default {
  checkDocument: function(documentId) {
    return axios.get('/process/check/' + documentId, {
      headers: getAuthHeaders()
    });
  },
  getDocumentStates: function(doc_id) {
    return axios.get('/process/document/' + doc_id, {
      headers: getAuthHeaders(),
    });
  },
  countWaitingTasks: function () {
    return axios.get(`/tasks`, {
      headers: getAuthHeaders(),
    });
  },
  getUserWaitingTasks: function(page) {
    return axios.get(`/tasks/pending?page=${page}`, {
      headers: getAuthHeaders(),
    });
  },
  getUserApprovedTasks: function(page) {
    return axios.get(`/tasks/completed?page=${page}`, {
      headers: getAuthHeaders(),
    });
  },
  getUserRejectedTasks: function(page) {
    return axios.get(`/tasks/sent?page=${page}`, {
      headers: getAuthHeaders(),
    });
  },
  getDocumentStateActions: function(documentId) {
    return axios.get('process/state-actions/' + documentId, {
      headers: getAuthHeaders(),
    });
  },
  getDocumentCurrentState: function (documentId) {
    return axios.get('/document-state/' + documentId, {
      headers: getAuthHeaders(),
    });
  },
  changeDocumentState: function(payload) {
    return axios.post('process/change-state', payload, {
      headers: getAuthHeaders(),
    });
  },
}